import styled from 'styled-components';

import InfiniteScrollDropdown from '~/components/InfiniteScrollDropdown';

export const StyledInfiniteScrollDropdown = styled(InfiniteScrollDropdown)`
  & > button {
    height: 100%;
    ${(props) => (props.variant === 'header' ? '' : 'width: 100%;')}
  }
`;
